<template>
  <div>
    <b-form-checkbox
        v-if="false"
        :id="checkBoxId"
        v-model="status"
        :name="checkBoxId"
        value="accepted"
        unchecked-value="not_accepted"
    >
      {{item}}
    </b-form-checkbox>
    <li>
      {{processItem(item)}}
    </li>

    <div v-if="false">State: <strong>{{ status }}</strong></div>
  </div>
</template>

<script>
export default {
  name: "Action_Item",
  components: {},
  created(){},
  mounted() {},
  props: {
    idx: {
      type: Number,
      required: false,
      default: 0
    },
    item: {
      type: String,
      required: false,
      default:null
    }
  },
  computed: {},
  methods: {
    processItem(item){
      if (typeof item === "string") return this.stripMarkupsAndHTML(item);
      if (typeof item === "object") return this.processObject(item);
    },
    processObject(itemObj){
      //Count the Keys
      if (Object.keys(itemObj).length == 1) {
        if (itemObj && itemObj.text) return itemObj.text;
        if (itemObj && itemObj.action) return itemObj.action;
        if (itemObj && itemObj.action_statement) return itemObj.action_statement;
      }
      if (Object.keys(itemObj).length == 2) {
        if (itemObj && itemObj.action && itemObj.reason)
          return `${itemObj.action} So that: ${itemObj.reason}`;
      }
    },
    stripMarkupsAndHTML(itemText){
      let itemTextStr = itemText;
      var specialChars = "!@#$^&%*()+=-[]\/{}|:<>?,.";

      for (var i = 0; i < specialChars.length; i++) {
        itemTextStr = itemTextStr.replace(new RegExp("\\" + specialChars[i], "gi"), "");
      }
      return itemTextStr;
    }
  },
  data() {
    return {
      checkBoxId:`checkbox_${this.idx}`,
      status: 'not_accepted'
    };
  }
};
</script>

<style lang="scss" scoped>
</style>
